import { getAccessToken, getApiDomain, setApiDomain } from "@/auth";

export const getDomain = () => getApiDomain();
export const getToken = () => {
  const bearer = getAccessToken();

  if (bearer) return { headers: { Authorization: `Bearer ${bearer}` } };
  return {};
};
export const setDomain = ($domain) => {
  setApiDomain($domain);
};
